import React from 'react';
import { BoxV2 as Box, SxProps } from 'portal-commons';

const InfoItem: React.FC<{
  label: string;
  fallback?: string;
  testId?: string;
}> = ({ label, children, fallback = 'N/A', testId }) => (
  <Box sx={{ fontWeight: 400 }} data-testid={testId}>
    <Box
      as="span"
      sx={{
        fontSize: '12px',
        color: 't.black60',
        mb: '2px',
        textTransform: 'uppercase',
        display: 'block',
        lineHeight: '20px',
      }}
    >
      {label}
    </Box>
    <Box
      as="span"
      sx={{
        fontSize: '14px',
        color: 't.black70',
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
      }}
    >
      {children || fallback}
    </Box>
  </Box>
);

type InfoRowComposition = {
  Item: React.FC<{ label: string; testId?: string }>;
};

const InfoRow: React.FC<{ col?: number; sx?: SxProps }> &
  InfoRowComposition = ({ children, col = 4, sx }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: `repeat(${col}, 1fr)`,
      rowGap: '24px',
      columnGap: '16px',
      width: '100%',
      ...sx,
    }}
  >
    {children}
  </Box>
);

InfoRow.Item = InfoItem;

export default InfoRow;
